/// <reference types="@helsenorge/framework-utils/types/hn"/>

import { getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';

export enum TimerKeys {
  SignOutCountdown = 'signOutCountdown',
  AutomaticSignOut = 'automaticSignOut',
  AutomaticSignOutWarning = 'automaticSignOutWarning',
  SoonAutoSignOutEvent = 'soonAutoSignOutEvent',
}

declare global {
  interface Window {
    [TimerKeys.SignOutCountdown]?: number;
    [TimerKeys.AutomaticSignOut]?: number;
    [TimerKeys.AutomaticSignOutWarning]?: number;
    [TimerKeys.SoonAutoSignOutEvent]?: number;
  }
}

export const createCrossDomainIFrame = (): void => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${getTjenesterUrl()}/Core/CrossDomain/SessionKeepAlive`;
  iframe.id = 'cross_domain_iframe';
  document.body.appendChild(iframe);
};

interface SessionConfig {
  countdown: number;
  warnUserWhenRemaining: number;
  tokenLifetime: number;
}
export const getSessionConfig = (): SessionConfig => ({
  countdown: window.HN?.Rest?.TokenCountdown ?? 0,
  warnUserWhenRemaining: window.HN?.Rest?.TokenWarnUserWhenRemaining ?? 0,
  tokenLifetime: window.HN?.Rest?.TokenLifetime ?? 0,
});

export const getCountdownTime = (countdown: number): { minutes: number; seconds: number } => {
  if (countdown < 0) {
    return { minutes: 0, seconds: 0 };
  }
  const minutes = Math.floor(countdown / 60000);
  const diff = countdown - minutes * 60000;
  const seconds = Math.floor(diff / 1000);
  return { minutes, seconds };
};

const clearTimer = (timerId: TimerKeys): void => {
  if (!!window[timerId] && window[timerId] > -1) {
    clearTimeout(window[timerId]);
    window[timerId] = -1;
  }
};

export const setTimer = (timerId: TimerKeys, callback: () => void, timeout: number): void => {
  clearTimer(timerId);
  window[timerId] = window.setTimeout(callback, timeout);
};

const clearIntervalTimer = (intervalId: TimerKeys): void => {
  if (!!window[intervalId] && window[intervalId] > -1) {
    window.clearInterval(window[intervalId]);
    window[intervalId] = -1;
  }
};

export const stopAllTimers = (): void => {
  const timerIds: TimerKeys[] = [
    TimerKeys.AutomaticSignOut,
    TimerKeys.AutomaticSignOutWarning,
    TimerKeys.SignOutCountdown,
    TimerKeys.SoonAutoSignOutEvent,
  ];

  timerIds.forEach(timerId => {
    clearTimer(timerId);
    clearIntervalTimer(timerId);
  });
};
